<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import SecondhandGuaranteeInsuranceData from '@/data/company-page-data/turk-nippon-sigorta/cross-pages/SecondhandGuaranteeInsurance'
export default {
  metaInfo: {
    title: 'Türk Nippon İkinci El Araç Garanti Sigortası İçin Teklif Alın',
    meta: [
      {
        name: 'description',
        content: 'Türk Nippon İkinci El Garanti Sigortası ile satın almış olduğunuz ikinci el aracınızda oluşabilecek, dış etkenlerden kaynaklanmayan arızaları güvence altına alın.'
      }
    ]
  },
  name: 'TurkNipponSigortaSecondhandGuaranteeInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: SecondhandGuaranteeInsuranceData.headerContent,
      crossPageContent: SecondhandGuaranteeInsuranceData.crossPageContent,
      faqTitle: SecondhandGuaranteeInsuranceData.faqTitle,
      faqTitleDesc: SecondhandGuaranteeInsuranceData.faqTitleDesc,
      getPrice: SecondhandGuaranteeInsuranceData.getPrice
    }
  }
}
</script>
